(() => {
  'use strict';
  if (window.ewProductHalloweenSync) return;
  window.ewProductHalloweenSync = true;

  let source;
  let observer;
  const units = ['days', 'hours', 'minutes', 'seconds'];

  function sync() {
    const values = units.map(unit => source?.querySelector(`[data-unit="${unit}"]`)?.textContent.trim());
    const active = source?.isConnected && !source.hidden && values.every(value => /^\d+$/.test(value || ''));
    document.querySelectorAll('[data-halloween-product-countdown]').forEach(countdown => {
      countdown.hidden = !active;
      if (!active) return;
      units.forEach((unit, index) => {
        const digit = countdown.querySelector(`[data-halloween-product-unit="${unit}"]`);
        if (digit && digit.textContent !== values[index]) digit.textContent = values[index];
      });
      const label = source.querySelector('[role="timer"]')?.getAttribute('aria-label');
      if (label) countdown.querySelector('[role="timer"]')?.setAttribute('aria-label', label);
    });
  }

  function connect() {
    observer?.disconnect();
    source = document.querySelector('[data-halloween-bar]');
    if (source) {
      observer = new MutationObserver(sync);
      observer.observe(source, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['hidden', 'aria-label']
      });
    }
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
  document.addEventListener('visibilitychange', connect);
  window.addEventListener('pageshow', connect);
})();
